module.exports = __webpack_public_path__ + "img/fjjt1.708ff5c9.png";